<template>
    <div>
        <q-content-submenu></q-content-submenu>
        <v-container fluid class="px-5 transparent q-sticky-buffer">
            <v-row class="mx-5">
                <v-col cols=12>
                    <v-card class="pb-2">
                        <q-closed-policy-data-table :agent="getAgent" :rows="25" title="Closed Policies" :stat-type="this.$route.query.statType" :start-date="startDate" :end-date="endDate" v-on:resetparams="resetParams()"></q-closed-policy-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
//table data + search
import QClosedPolicyDataTable from '@/components/datatables/QClosedPolicyDataTable.vue';
import QContentSubmenu from '@/components/navigation/Submenus/QContentSubmenu.vue';
import QTabs from '../../components/navigation/QTabs.vue'


export default {
    data() {
        return {
            search: '',
            is_reset : false
        }
    },
    mounted: function() {},
    computed: {
        getAgent: function() {
            if (this.hasRole(['SuperAdmin', 'Staff'])){
                return {"AgentCode" : this.current_tenant.TopLevelAgentCode};
            }
            return this.user.Agent
        },
        startDate: function(){
            if (this.is_reset){
                return null;
            }
            return this.$route.params.startDate
        },
        endDate: function(){
            if (this.is_reset){
                return null;
            }
            return this.$route.params.endDate
        }
    },
    methods: {
        resetParams : function(){
            this.is_reset = true
        }
    },

    watch : {
        '$route.params.agent_code' : function(){
            this.is_reset = false
        }
    },
    components: {
        QClosedPolicyDataTable,
        QTabs,
        QContentSubmenu
    },
}
</script>